import type React from 'react';

function PostnordIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 50.25 50.25"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>Postnord Icon</title>

      <g id="Lager_1" data-name="Lager 1">
        <rect width="50.22" height="50.22" fill="none" />
        <path
          d="M1.2,11.64c2.23,0,4.45,.11,6.68,0,1.11,0,1.45,.22,1.34,1.34v.56c1.11-1.11,2.56-1.89,4.12-2.23,5.34-1.45,10.8,1.78,12.25,7.13,.11,.56,.22,1.11,.33,1.56,.67,3.34-.11,6.79-2.12,9.58-3.45,4.45-9.8,5.46-14.48,2.34v7.35h-.56c-.33-.33-.67-.22-1.11-.22H1.2V11.64Zm16.37,10.69c.11-2.34-1.67-4.23-4.01-4.34h-.33c-2.34,0-4.23,1.78-4.34,4.12v.33c0,2.34,1.78,4.34,4.12,4.34h.33c2.34,0,4.23-1.89,4.23-4.12v-.33Z"
          fill="inherit"
        />
        <path
          d="M1.2,39.14H7.77c.33,0,.78-.11,1.11,.22H1.76c-.22,0-.56,.22-.56-.22Z"
          fill="inherit"
        />
        <path
          d="M35.99,13.53c2.78-2.78,5.9-3.12,9.24-2.12,2.9,.78,4.79,3.45,4.9,7.02,.11,4.68,0,9.35,.11,14.03,0,.56-.22,.67-.78,.67h-6.46c-.67,0-.89-.22-.89-.89v-10.47c0-.33,0-.78-.11-1.11-.33-1.78-1.11-2.45-2.56-2.45-1.56-.22-3.12,.78-3.34,2.34h0c-.11,.56-.11,1.11-.11,1.67v9.91c0,.89-.22,1-1,1h-6.12c-.67,0-.78-.11-.78-.78V12.42c0-.67,.22-.78,.78-.78h6.01c.89,0,1.34,.22,1.11,1.11v.78Z"
          fill="inherit"
        />
      </g>
    </svg>
  );
}

export default PostnordIcon;
